import { useEffect, useState } from 'react'
import { LOCATION_SEARCH_TYPE } from '@/types'
import useRecentSearchCard from './useRecentSearchCard'
import useRecommendations from './useRecommendations'

type CityID = {
  value: string
}

export default function useRecentSearchesExperiment(
  cguid: string,
  appName: string,
  appVersion: string
) {
  const [recentLocations, setRecentLocations] = useState<
    LOCATION_SEARCH_TYPE[]
  >([])
  const [cityIdList, setCityIdList] = useState<CityID[]>([])

  const data = useRecentSearchCard(cguid, { appName, appVersion }, 'STAY')

  useEffect(() => {
    data.forEach(item => {
      if ('stayDestinationData' in item) {
        const { cityID } = item.stayDestinationData[0].destinationCityData
        setCityIdList(prevCityId => [...prevCityId, { value: cityID }])
      }
    })
  }, [data])

  const cityInfoList = useRecommendations(
    { cityId: cityIdList },
    cityIdList.length > 0
  )
  useEffect(() => {
    cityInfoList.forEach(item => {
      setRecentLocations(oldCityInfoList => [
        ...oldCityInfoList,
        {
          ...item,
          country: item.countryName,
          entered: '',
          highlightedName: null,
          id: item.cityID.toString(),
          type: 'CITY',
          cityID: item.cityID.toString()
        }
      ])
    })
  }, [cityInfoList])
  return recentLocations
}
